import Vue from 'vue';
//@ts-ignore
import Newsletter from '../Newsletter/Newsletter.vue';
Vue.config.productionTip = false;
var initializeNewsletter = function () {
    var newsletterContainer = document.getElementById('newsletterContainer');
    if (newsletterContainer !== null) {
        new Vue({
            render: function (h) { return h(Newsletter, {
                props: {
                    servicenewsletterid: newsletterContainer.dataset.servicenewsletterid,
                    reference: newsletterContainer.dataset.reference,
                    headline: newsletterContainer.dataset.headline,
                    title: newsletterContainer.dataset.title,
                    content: newsletterContainer.dataset.content,
                    promoId: typeof newsletterContainer.dataset.promoid !== 'undefined' ? newsletterContainer.dataset.promoid : '',
                    promotion: typeof newsletterContainer.dataset.promotion !== 'undefined' ? newsletterContainer.dataset.promotion : ''
                }
            }); },
        }).$mount('#newsletterContainer');
    }
};
export default initializeNewsletter;
